import { render, staticRenderFns } from "./gc-popup.vue?vue&type=template&id=75dbfd7f&scoped=true"
import script from "./gc-popup.vue?vue&type=script&lang=js"
export * from "./gc-popup.vue?vue&type=script&lang=js"
import style0 from "./gc-popup.vue?vue&type=style&index=0&id=75dbfd7f&prod&lang=scss"
import style1 from "./gc-popup.vue?vue&type=style&index=1&id=75dbfd7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dbfd7f",
  null
  
)

export default component.exports